import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    const metaTags: Record<string, string> = {
      description: description,
      keywords: keywords,
      'og:title': ogTitle || title,
      'og:description': ogDescription || description,
      'og:type': ogType,
      'og:url': canonicalUrl,
      'og:locale': 'zh_CN',
      'twitter:card': 'summary_large_image',
      'twitter:title': ogTitle || title,
      'twitter:description': ogDescription || description,
    };

    const elements: HTMLElement[] = [];

    Object.entries(metaTags).forEach(([name, content]) => {
      let el: HTMLElement | null;
      if (name.startsWith('og:')) {
        el = document.querySelector(`meta[property="${name}"]`);
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute('property', name);
          document.head.appendChild(el);
        }
      } else if (name.startsWith('twitter:')) {
        el = document.querySelector(`meta[name="${name}"]`);
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute('name', name);
          document.head.appendChild(el);
        }
      } else {
        el = document.querySelector(`meta[name="${name}"]`);
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute('name', name);
          document.head.appendChild(el);
        }
      }
      if (el) {
        el.setAttribute('content', content);
        elements.push(el);
      }
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);

    return () => {
      elements.forEach((el) => el.remove());
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType]);

  return null;
}